export const stateName = 'systemConfiguration' as const
